module.exports = __webpack_public_path__ + "img/TechMarketTribute2_ua.aa4d7a83.webp";